import type { PaletteColor } from "@mui/material";
import type { Components, Theme } from "@mui/material/styles";

import type { ColorName } from "../../options/palette";

export const MuiTextField: Components<Theme>["MuiTextField"] = {
  defaultProps: {
    variant: "outlined",
  },
  styleOverrides: {
    root: ({ theme }) => ({
      variants: [
        {
          props: {
            variant: "standard",
          },
          style: {
            "& > .MuiInput-root": {
              // add a transparent border in all cases to avoid moving text
              border: `${theme.spacing(0.25)} solid transparent`,
              borderRadius: theme.shape.borderRadius,

              "&.Mui-focused": {
                borderColor: theme.palette.primary.main,
              },
            },
          },
        },
        ...Object.entries(theme.palette)
          .filter(
            ([, values]) => typeof values === "object" && "main" in values
          )
          .map(([colorName, colorValues]: [ColorName, PaletteColor]) => ({
            props: {
              color: colorName,
              variant: "standard" as const,
            },
            style: {
              "& > .MuiInput-root.Mui-focused": {
                borderColor: colorValues.main,
              },
            },
          })),
      ],
    }),
  },
};
